import { IdentifiableObjectDTO } from '@dto/IdentifiableObjectDTO';

export class QualificationDTO extends IdentifiableObjectDTO<number> {
  public name: string;
}
